/* Five Origins: wishlist fara aplicatie. Lista sta in browserul clientului
   (localStorage), deci nu se sincronizeaza intre dispozitive. */
(function () {
  'use strict';
  var CHEIE = 'fo-wishlist';
  var INIMA = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 20.5s-7.5-4.6-9.3-9.2C1.5 8 3.6 4.8 6.9 4.8c2.1 0 3.8 1.1 5.1 3 1.3-1.9 3-3 5.1-3 3.3 0 5.4 3.2 4.2 6.5-1.8 4.6-9.3 9.2-9.3 9.2z"/></svg>';
  var CALM = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var ARC = 'cubic-bezier(.2,1.25,.35,1)';
  var LIN = 'cubic-bezier(.2,.8,.2,1)';
  var lista = citeste();

  function citeste() {
    try { return JSON.parse(localStorage.getItem(CHEIE)) || []; } catch (e) { return []; }
  }
  function salveaza() {
    try { localStorage.setItem(CHEIE, JSON.stringify(lista)); } catch (e) {}
  }
  function handleDin(href) {
    var m = String(href || '').match(/\/products\/([^\/?#]+)/);
    return m ? m[1] : '';
  }
  function comuta(h) {
    var i = lista.indexOf(h);
    if (i > -1) lista.splice(i, 1); else lista.unshift(h);
    salveaza();
    actualizeaza();
  }
  function actualizeaza() {
    document.querySelectorAll('[data-fo-wl]').forEach(function (b) {
      var on = lista.indexOf(b.getAttribute('data-fo-wl')) > -1;
      b.setAttribute('aria-pressed', String(on));
      b.setAttribute('aria-label', on ? 'Scoate din wishlist' : 'Adaugă în wishlist');
    });
    var nr = document.querySelector('.fo-wl-head b');
    if (nr) { nr.textContent = lista.length; nr.hidden = lista.length === 0; }
  }
  function strat(css) {
    var e = document.createElement('i');
    e.style.cssText = 'position:fixed;z-index:2147483000;pointer-events:none;' + css;
    document.body.appendChild(e);
    return e;
  }
  function animaInima(b, adaugata) {
    if (CALM) return;
    var svg = b.querySelector('svg');
    if (svg) svg.animate([{ transform: 'scale(.6)' }, { transform: 'scale(1.25)' }, { transform: 'scale(1)' }], { duration: 450, easing: ARC });
    if (!adaugata) return;
    var a = b.getBoundingClientRect();
    var cx = a.left + a.width / 2, cy = a.top + a.height / 2;
    for (var i = 0; i < 8; i++) {
      (function (u) {
        var s = strat('left:' + (cx - 3) + 'px;top:' + (cy - 3) + 'px;width:6px;height:6px;border-radius:50%;background:#c8321e;');
        s.animate([
          { transform: 'none', opacity: 1 },
          { transform: 'translate(' + Math.cos(u) * 34 + 'px,' + Math.sin(u) * 34 + 'px) scale(.2)', opacity: 0 }
        ], { duration: 520, easing: LIN }).onfinish = function () { s.remove(); };
      })(i / 8 * Math.PI * 2);
    }
    var cap = document.querySelector('.fo-wl-head');
    if (!cap) return;
    var nr = cap.querySelector('b');
    var c = cap.getBoundingClientRect();
    var dx = c.left + c.width / 2 - cx, dy = c.top + c.height / 2 - cy;
    var f = strat('left:' + (cx - 11) + 'px;top:' + (cy - 11) + 'px;width:22px;height:22px;color:#c8321e;');
    f.innerHTML = INIMA.replace('<svg ', '<svg style="width:100%;height:100%;fill:currentColor;display:block" ');
    if (nr) nr.style.visibility = 'hidden';
    f.animate([
      { transform: 'none', opacity: 1 },
      { transform: 'translate(' + dx * .5 + 'px,' + (dy * .5 - 26) + 'px) scale(1.15)', offset: .55 },
      { transform: 'translate(' + dx + 'px,' + dy + 'px) scale(.6)', opacity: .9 }
    ], { duration: 650, easing: LIN, delay: 60, fill: 'both' }).onfinish = function () {
      f.remove();
      if (nr) {
        nr.style.visibility = '';
        nr.animate([{ transform: 'scale(.2)' }, { transform: 'scale(1.25)' }, { transform: 'scale(1)' }], { duration: 420, easing: ARC });
      }
      cap.animate([{ transform: 'scale(1)' }, { transform: 'scale(1.16)' }, { transform: 'scale(1)' }], { duration: 320 });
    };
  }
  function buton(h) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'fo-wl-btn';
    b.setAttribute('data-fo-wl', h);
    b.innerHTML = INIMA;
    return b;
  }
  function scaneaza() {
    document.querySelectorAll('.fo-card__link, .fo-ved__p').forEach(function (a) {
      var h = handleDin(a.getAttribute('href'));
      var img = a.querySelector('img');
      if (!h || !img) return;
      var gazda = a.querySelector('.fo-card__media') || img.parentElement;
      if (gazda.querySelector('[data-fo-wl]')) return;
      gazda.classList.add('fo-wl-host');
      gazda.appendChild(buton(h));
    });
    var hp = handleDin(location.pathname);
    if (hp && location.pathname.indexOf('/products/') > -1) {
      var galerie = document.querySelector('.product-information__media slideshow-container') || document.querySelector('.product-information__media media-gallery');
      if (galerie && !galerie.querySelector('[data-fo-wl]')) {
        var b = buton(hp);
        b.style.top = '12px';
        b.style.right = '12px';
        b.style.bottom = 'auto';
        galerie.classList.add('fo-wl-host');
        galerie.appendChild(b);
      }
    }
    actualizeaza();
  }
  function pretLei(bani) {
    return (bani / 100).toLocaleString('ro-RO', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' lei';
  }
  var dlg;
  function deschide() {
    if (!dlg) {
      dlg = document.createElement('dialog');
      dlg.className = 'fo-wl-dlg';
      dlg.setAttribute('aria-label', 'Wishlist');
      dlg.innerHTML = '<div class="fo-wl-dlg__top"><h2>Wishlist</h2><button type="button" class="fo-wl-x" aria-label="Închide">&times;</button></div><div data-wl-lista></div>';
      document.body.appendChild(dlg);
      dlg.addEventListener('click', function (e) {
        if (e.target === dlg || e.target.closest('.fo-wl-x')) dlg.close();
        var s = e.target.closest('.fo-wl-sterge');
        if (s) { comuta(s.getAttribute('data-h')); deseneaza(); }
      });
    }
    deseneaza();
    dlg.showModal();
  }
  function deseneaza() {
    var el = dlg.querySelector('[data-wl-lista]');
    if (!lista.length) {
      el.innerHTML = '<p class="fo-wl-gol">Nu ai salvat nicio cafea încă. <a href="/collections/cafea-de-specialitate">Vezi cafelele</a></p>';
      return;
    }
    el.innerHTML = '';
    lista.forEach(function (h) {
      var rand = document.createElement('div');
      rand.className = 'fo-wl-item';
      el.appendChild(rand);
      fetch('/products/' + encodeURIComponent(h) + '.js').then(function (r) {
        if (!r.ok) throw new Error('lipsa');
        return r.json();
      }).then(function (p) {
        var img = document.createElement('img');
        img.src = p.featured_image || '';
        img.alt = '';
        img.loading = 'lazy';
        var mij = document.createElement('div');
        var a = document.createElement('a');
        a.href = p.url;
        a.textContent = p.title;
        var pret = document.createElement('span');
        pret.textContent = (p.price_varies ? 'de la ' : '') + pretLei(p.price_min);
        mij.appendChild(a);
        mij.appendChild(pret);
        var st = document.createElement('button');
        st.type = 'button';
        st.className = 'fo-wl-sterge';
        st.setAttribute('data-h', h);
        st.textContent = 'Scoate';
        rand.appendChild(img);
        rand.appendChild(mij);
        rand.appendChild(st);
      }).catch(function () {
        lista.splice(lista.indexOf(h), 1);
        salveaza();
        rand.remove();
        actualizeaza();
      });
    });
  }
  function pornesteAntet() {
    var cart = document.querySelector('.header-actions__cart-icon');
    if (!cart || document.querySelector('.fo-wl-head')) return;
    var gazda = cart.closest('.header-actions__action') || cart;
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'fo-wl-head';
    b.setAttribute('aria-label', 'Deschide wishlist');
    b.innerHTML = INIMA + '<b hidden>0</b>';
    b.addEventListener('click', deschide);
    gazda.parentNode.insertBefore(b, gazda);
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-fo-wl]');
    if (!b) return;
    e.preventDefault();
    e.stopPropagation();
    var h = b.getAttribute('data-fo-wl');
    var adaugata = lista.indexOf(h) === -1;
    comuta(h);
    animaInima(b, adaugata);
  }, true);

  /* Cutia Sixt Pack: fiecare cafea cade la locul ei, iar la a sasea apare reducerea reala din sumar. */
  function pornesteCutia() {
    var box = document.querySelector('.fsp__box');
    var slots = box && box.querySelector('[data-fsp-slots]');
    if (!slots || CALM) return;
    var pline = function () { return Array.prototype.filter.call(slots.children, function (s) { return s.dataset.filled === '1'; }); };
    var inainte = pline().length;
    var cititi = new Set(pline().map(function (s) { return s.dataset.slot; }));
    var t;
    function verifica() {
      var acum = pline();
      var noi = acum.filter(function (s) { return !cititi.has(s.dataset.slot); });
      noi.forEach(function (s, i) {
        s.animate([
          { transform: 'translateY(-46px) scale(1.12)', opacity: 0 },
          { transform: 'none', opacity: 1 }
        ], { duration: 560, easing: ARC, delay: i * 70, fill: 'backwards' });
      });
      if (acum.length === 6 && inainte < 6) arataReducerea(box, slots);
      inainte = acum.length;
      cititi = new Set(acum.map(function (s) { return s.dataset.slot; }));
    }
    new MutationObserver(function () { clearTimeout(t); t = setTimeout(verifica, 30); }).observe(slots, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-filled'] });
  }
  function arataReducerea(box, slots) {
    var save = box.querySelector('[data-fsp-save]');
    var m = save && save.textContent.match(/(\d+)\s*%/);
    if (!m) return;
    var tinta = +m[1];
    var r = slots.getBoundingClientRect();
    var e = strat('left:' + r.left + 'px;top:' + r.top + 'px;width:' + r.width + 'px;height:' + r.height + 'px;display:grid;place-items:center;font-weight:800;font-size:clamp(64px,9vw,104px);line-height:1;font-style:normal;letter-spacing:-.04em;color:#ee7a1c;text-shadow:0 2px 24px #0000008c;');
    e.textContent = '0%';
    var t0 = performance.now();
    (function pas(t) {
      var p = Math.min(1, (t - t0) / 650);
      e.textContent = Math.round(tinta * (1 - Math.pow(1 - p, 3))) + '%';
      if (p < 1) requestAnimationFrame(pas);
    })(t0);
    e.animate([
      { opacity: 0, transform: 'scale(.8)' },
      { opacity: 1, transform: 'scale(1.06)', offset: .2 },
      { opacity: 1, transform: 'scale(1)', offset: .75 },
      { opacity: 0, transform: 'scale(1)' }
    ], { duration: 1900, easing: LIN }).onfinish = function () { e.remove(); };
    var total = box.querySelector('[data-fsp-total]');
    if (total) total.animate([{ transform: 'scale(1)' }, { transform: 'scale(1.1)' }, { transform: 'scale(1)' }], { duration: 480, easing: ARC, delay: 300 });
  }

  function porneste() {
    pornesteAntet();
    scaneaza();
    pornesteCutia();
    var t;
    new MutationObserver(function () {
      clearTimeout(t);
      t = setTimeout(function () { pornesteAntet(); scaneaza(); }, 150);
    }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', porneste); else porneste();
})();
